var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragAndDrop = function SvgDragAndDrop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 150,
    viewBox: "0 0 70 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6336 69.7189L30.2646 57.502L49.1306 38.8682L67.9998 57.502L55.6308 69.7189H42.6336Z",
    fill: "#C7D2FE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.583 69.7185L49.144 63.2236L55.7083 69.7185H42.583Z",
    fill: "#A6B3FB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.749 51.0459C42.8426 52.1285 42.0201 52.9397 43.1137 54.0223C44.2073 55.1049 45.0299 54.2937 46.1235 55.3763C47.2171 56.4589 46.3946 57.27 47.4913 58.3526",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0303 48.6104C46.1238 49.6926 45.3044 50.5035 46.3979 51.5857C47.4915 52.6679 48.3108 51.857 49.4043 52.9392C50.4978 54.0215 49.6785 54.8323 50.772 55.9146C51.8655 56.9968 52.6848 56.1859 53.7783 57.2681C54.8719 58.3503 54.0525 59.1612 55.146 60.2466C56.2395 61.3319 57.062 60.5179 58.1555 61.6001",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1318 45.3623C50.2253 46.4414 49.406 47.2554 50.4995 48.3376C51.593 49.4199 52.4124 48.6058 53.5059 49.6881C54.5994 50.7703 53.78 51.5843 54.8735 52.6665C55.9671 53.7487 56.7864 52.9378 57.8799 54.0201C58.9734 55.1023 58.1541 55.9132 59.2476 56.9954C60.3411 58.0776 61.1636 57.2667 62.2571 58.3521",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5735 32.9411L15.0814 34.1139L13.0229 12.2595L35.129 10.4687L36.4785 24.797L29.5735 32.9411Z",
    fill: "#818CF8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5655 32.9413L28.812 25.3663L36.4823 24.7833L29.5655 32.9413Z",
    fill: "#6D75E8"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9961 23.4414C18.279 23.339 18.3679 24.2912 19.6508 24.1888C20.9338 24.0864 20.8448 23.1343 22.1278 23.0319C23.4107 22.9295 23.4996 23.8817 24.7842 23.7773",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1611 20.0742C18.4437 19.9717 18.5342 20.9217 19.8168 20.8192C21.0994 20.7167 21.009 19.7667 22.2916 19.6642C23.5742 19.5616 23.6646 20.5116 24.9473 20.4091C26.2299 20.3066 26.1394 19.3566 27.422 19.2541C28.7047 19.1516 28.7951 20.1016 30.0797 20.0008C31.3644 19.8999 31.2736 18.9463 32.5562 18.8437",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2344 15.7549C18.515 15.6507 18.6074 16.6024 19.8901 16.4999C21.1727 16.3973 21.0802 15.4457 22.3628 15.3431C23.6454 15.2406 23.7379 16.1923 25.0205 16.0898C26.3031 15.9873 26.2127 15.0373 27.4953 14.9348C28.7779 14.8323 28.8683 15.7823 30.151 15.6797C31.4336 15.5772 31.3448 14.6252 32.6294 14.5244",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9662 110.654L65.356 145.63C65.1919 146.829 64.5477 147.917 63.5639 148.654C62.756 149.248 61.7708 149.568 60.7588 149.566H9.29315C8.2912 149.567 7.31758 149.242 6.52702 148.642C5.54022 147.91 4.89115 146.827 4.72189 145.63L0.0337545 110.654C-0.045336 110.019 0.0149405 109.375 0.210593 108.764C0.406246 108.153 0.732811 107.59 1.16867 107.112C1.60453 106.633 2.13973 106.25 2.73886 105.988C3.33798 105.727 3.98735 105.592 4.64397 105.593H65.356C66.0127 105.592 66.662 105.727 67.2611 105.988C67.8603 106.25 68.3955 106.633 68.8313 107.112C69.2672 107.59 69.5938 108.153 69.7894 108.764C69.9851 109.375 70.0453 110.019 69.9662 110.654Z",
    fill: "#E5E7EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.53 99.0122V105.567H6.49316V91.0022C6.49313 89.5992 7.06243 88.2531 8.07691 87.2575C9.09138 86.2619 10.4687 85.6975 11.9085 85.6875H27.7262C28.8268 85.687 29.8844 86.1042 30.6748 86.8507C31.4651 87.5971 31.926 88.6142 31.9598 89.6862C31.994 90.7642 32.4602 91.7862 33.2584 92.5333C34.0453 93.2846 35.1047 93.703 36.2064 93.6975H58.0627C59.5105 93.6975 60.8991 94.257 61.9241 95.2534C62.9491 96.2497 63.5266 97.6015 63.53 99.0122Z",
    fill: "#A8AFBA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragAndDrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "drag-and-drop.7aa16f723cd4d5a42634c6c85a868050.svg";